import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const WarningDiv = styled.div.attrs({ className: "notification is-warning is-light" })`
    position: absolute;
    bottom: 50px;
`;

const LoadWarning = (props) => {
    return (
        <WarningDiv>
            We need to load { Math.floor(props.percentGoal) }% of the movie. We&apos;ve loaded { Math.floor(props.percentLoaded) }% so far. Please wait..
        </WarningDiv>
    );
};

LoadWarning.propTypes = {
    percentGoal: PropTypes.number.isRequired,
    percentLoaded: PropTypes.number.isRequired
};

export { LoadWarning };
